/**
 * sudimage-drawers.js
 * @author      Marc-André Appel <marc-andre@sudimage.fr>
 * @copyright   2016 Sudimage Communication
 * @license     http://opensource.org/licenses/MIT MIT
 * @link        http://www.sudimage.fr
 */
/* globals CCM_EDIT_MODE */

(function () {
  function setupDrawers() {
    var drawers = [];
    var distance = 70;
    var breakpoint = Math.floor($(window).height() / 2.75); //distance + $('.header').outerHeight();
    var newBreakpoint;
    var i;
    if (CCM_EDIT_MODE !== true) {
      $('.drawer-right').each(function () {
        var $this = $('.drawer-controls', this);
        drawers.push($this);
      });
      if (drawers.length > 0) {
        drawers[0].css({top: breakpoint});
        newBreakpoint = breakpoint;
        for (i = 1; i < drawers.length; i++) {
          newBreakpoint = newBreakpoint + distance;
          drawers[i].css({top: newBreakpoint});
        }
      }
      drawers = [];
      $('.drawer-left').each(function () {
        var $this = $('.drawer-controls', this);
        drawers.push($this);
      });
      if (drawers.length > 0) {
        drawers[0].css({top: breakpoint});
        newBreakpoint = breakpoint;
        for (i = 1; i < drawers.length; i++) {
          newBreakpoint = newBreakpoint + distance;
          drawers[i].css({top: newBreakpoint});
        }
      }
      $('.drawer-left .drawer-controls > a').hover(
        function () {
          if (!$(this).parents('.drawer').hasClass('open')) {
            $(this).css({
              marginRight: -Math.abs($(this).outerWidth())
            });
          }
        },
        function () {
          $(this).css({
            marginRight: '-58px'
          });
        }
      );
      $('.drawer-right .drawer-controls > a').hover(
        function () {
          if (!$(this).parents('.drawer').hasClass('open')) {
            $(this).css({
              marginLeft: -Math.abs($(this).outerWidth())
            });
          }
        },
        function () {
          $(this).css({
            marginLeft: '-58px'
          });
        }
      );
      if ($('.ccm-page').hasClass('page-type-intro')) {
        $('.drawer').each(function () {
          $(this).addClass('intro');
        });
      }
    }
  }
  /** Première visite - panneaux ouverts */
  function setCookie() {
    var d = new Date();
    d.setTime(d.getTime() + (2 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = "sudimageHasSeenDrawers=true; " + expires + "; path=/";
  }
  function getCookie() {
    var name = "sudimageHasSeenDrawers=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  function presentDrawers() {
    var hasSeen = getCookie();
    var drawersRight = [];
    var drawersLeft = [];
    if (hasSeen === "") {
      setCookie();
      $('.drawer-right .drawer-controls > a').each(function () {
        $(this).css({
          marginLeft: -Math.abs($(this).outerWidth())
        });
        drawersRight.push($(this));
      });
      var animateRight = function() {
        var reduceDrawerRight = function() {
          if (drawersRight.length === 0) {
            clearInterval(animationRight);
          } else {
            var drawer = drawersRight.shift();
            drawer.css({
              marginLeft: '-58px'
            });
          }
        };
        var animationRight = window.setInterval(reduceDrawerRight, 200);
      };
      window.setTimeout(animateRight, 3000);

      $('.drawer-left .drawer-controls > a').each(function () {
        $(this).css({
          marginRight: -Math.abs($(this).outerWidth())
        });
        drawersLeft.push($(this));
      });
      var animateLeft = function() {
        var reduceDrawerLeft = function() {
          if (drawersLeft.length === 0) {
            clearInterval(animationLeft);
          } else {
            var drawer = drawersLeft.shift();
            drawer.css({
              marginRight: '-58px'
            });
          }
        };
        var animationLeft = window.setInterval(reduceDrawerLeft, 200);
      };
      window.setTimeout(animateLeft, 3000);
    }
  }
  setupDrawers();
  $(window).resize(function () {
    setupDrawers();
  });
  presentDrawers();
})();

